import { FC } from "react";
import { Button } from "../../atoms/Button";
import { ButtonWrapper, Wrapper, Text } from "./elements";
import { Props } from "./types";
const OverlapScheduleConfirmationModalBody: FC<Props> = ({
  onConfirm,
  onCancel,
}) => {
  return (
    <>
      <Wrapper>
        <Text>
          This specific time and date was selected by the other interviewer.
          Would you like to add a schedule here?
        </Text>
        <ButtonWrapper>
          <Button type={"primary"} id="cancel_btn" onClick={onCancel}>
            No
          </Button>
          <Button type={"primary"} id="confirm_btn" onClick={onConfirm}>
            Yes
          </Button>
        </ButtonWrapper>
      </Wrapper>
    </>
  );
};

export default OverlapScheduleConfirmationModalBody;
